let React    = require('react');
let ReactDom = require('react-dom');

// -------------------------------------------------------

class StaticError extends React.Component {
  render() {
    return (
      <div id="login">
        <div className="login-box">
          <div className="login-logo" />

          <div className="box">
            <div className="auth0-notice">
              <span className="material-icons notice-icon">error_outline</span>
              <p className="notice-title">エラーが発生しました</p>
              <p className="notice-desc">
                ページを表示できませんでした。<br />
                URLをご確認のうえ、再度お試しください。
              </p>
            </div>

            <a className="auth0-login-button" href="/">
              <span className="material-icons">home</span>
              トップページへ戻る
            </a>
          </div>
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

export default StaticError;
